var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-panel-input-select',{attrs:{"items":_vm.paddings,"item-text":"text","return-object":true},model:{value:(_vm.padding),callback:function ($$v) {_vm.padding=$$v},expression:"padding"}})
}
var staticRenderFns = []

export { render, staticRenderFns }